import React, { useRef, useEffect } from 'react';
import {
  useLocation,
  Switch,
  Route,
  BrowserRouter as Router,
} from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode';
import setAuthToken from './utils/setAuthToken';
import { setCurrentUser, logoutUser } from './actions/authActions';
import { Provider } from 'react-redux';
import store from './store';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views
import Home from './views/Home';
import LoginPage from './views/LoginPage';
import RegisterPage from './views/RegisterPage';
import DashboardPage from './views/DashboardPage';

const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
  },
});

if (localStorage.jwtToken) {
  // set auth token header auth
  const token = localStorage.jwtToken;
  setAuthToken(token);

  // decode token and get user info
  const decoded = jwt_decode(token);

  // set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

  // check for expired token
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    // logout user
    store.dispatch(logoutUser());

    // redirect to login
    window.location.href = './login';
  }
}

const initialOptions = {
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: 'USD',
  intent: 'capture',
};

const App = () => {
  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    document.body.classList.add('is-loaded');
    childRef.current.init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Provider store={store}>
      <PayPalScriptProvider options={initialOptions}>
        <ThemeProvider theme={darkTheme}>
          <ScrollReveal
            ref={childRef}
            children={() => (
              <Switch>
                <Router>
                  <AppRoute
                    exact
                    path='/'
                    component={Home}
                    layout={LayoutDefault}
                  />
                  <Route exact path='/register' component={RegisterPage} />
                  <Route exact path='/login' component={LoginPage} />
                  <Route exact path='/dashboard' component={DashboardPage} />
                  {/* <Route exact path='/' component={Home} layout={LayoutDefault} /> */}
                </Router>
              </Switch>
            )}
          />
        </ThemeProvider>
      </PayPalScriptProvider>
    </Provider>
  );
};

export default App;
